import { render, staticRenderFns } from "./IconRemove.vue?vue&type=template&id=7bdec95f&scoped=true"
import script from "./IconRemove.vue?vue&type=script&lang=js"
export * from "./IconRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdec95f",
  null
  
)

export default component.exports